import { useAuth } from '@/lib/auth';

// Backend-resolved context only; no industry inference or local profile cache.
export function useTradeFieldPresentation() {
  const { user, operatingProfile, refresh } = useAuth();
  const context = operatingProfile?.context;
  const field = user?.role === 'field';
  const known = !!(context && user?.org_id && context.org_id === user.org_id);
  return { user, refresh, pending: !!(field && user?.org_id && !known),
    trades: !!(field && known && context.mode === 'TRADES_SERVICES'),
    identity: JSON.stringify([user?.org_id, user?.id, user?.role]) };
}
